import { getAxiosInstance } from "../ApiConfig";

async function getCityData(isoCode) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCities/${isoCode}`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getStateData(isoCode) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllStates/${isoCode}`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllUsersData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllActiveUser`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllUsersByAdmin() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllUserByAdmin`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchAllAttendeeList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllParticipants`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function IndustryData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllIndustry`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLeadsourceData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadSource`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLeadStatusData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadStatus`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSeniorityLevelData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllSeniorityLevel`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCountryData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCountries`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getColumnConfigs(value) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/UserDataConfigs/${value}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function SharingPermissions(entity, id, sharingId) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/findSharingForPermission/${entity}/${id}/${sharingId}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function MultiFileUpload(formData) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/uploadMultipleFiles`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getMyTerritory() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/findAllTerritoryByAssignto`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTeamTerritory(value) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/findAllTerritoryByUserId/${value}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getBusinessRuleEntity() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllEntityTypeForAutomation`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTriggerFiledforEntity(name) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllRequestField/${name}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTimeZoneData() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllTimeZone`);
        const cleanedList = data.data.data.map(item => ({
            ...item,
            timeZone: item.timeZone.replace(/\s\d{2}:\d{2}:\d{2}$/, "")
        }));
        return cleanedList
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCompanyRole() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllCompanyRolesByUser`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllCompanyRoles() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllCompanyRoles`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSystemRole() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllSystemRoleByAdmin`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLanguage() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllLanguage`);
        return data.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTitle() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllTitle`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAnnualRevenue() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllAnnualRevenue`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getNoofEmployee() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllNomOfEmployee`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getRating() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllRating`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getProdCategory() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllProductCategory`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getUserDepartment() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllDepartment`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getDateFormate() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllDateFormat`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTimeFormate() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllTimeFormat`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchDealByEntity(id, entity) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getRelateEntityData/${id}/${entity}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getScoringDetails(name, id) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/findAllEntityScoringByEntityTypeAndId/${name}/${id}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getMailInfo(company, email) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchDetailUsingEmail/${company}/${email}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLeadMailInfo(company, email) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findByLeadByEmail/${company}/${email}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FecthModuleEncryptedToken(id, companyId) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/generateTokenUsingId/${id}/${companyId}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FecthModuleDecryptedToken(token, companyId) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/decodeToken/${token}/${companyId}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FecthTableNames() {
    try {
        const data = await getAxiosInstance().get(`/Template/getAllEntityTableName`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function LogOutApi(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/logOut`, payload);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getsyatemRolePermission(roleId) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/role/${roleId}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function taskReminderAndOverdue() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/taskReminderAndOverdue`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function approvalRequestReminderAndOverdue() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/approvalRequestReminderAndOverdue`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function checkedAccountExpire() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/checkedAccountExpire`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function triggerMailForExpiredTrialAccount() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/triggerMailForExpiredTrialAccount`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function loginStatus() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/login/status`);
        return data.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function triggerMailForExpiringTrialAccount() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/triggerMailForExpiringTrialAccount`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function login(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/login`, payload);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function loginFromTwoFactorAuthentication(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/loginFromTwoFactorAuthentication`, payload);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function forgotPassword(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/forgotPassword`, payload);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function sendEmailOtpForForgotPassword(email, payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/sendEmailOtpForForgotPassword/${email}`, payload);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function resetNewPassword(email, payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/resetNewPassword/${email}`, payload);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createExportLog(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createExportLog`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllActivityByType1(apiType, id) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllActivityByType/${apiType}/${id}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllActivityByType(apiType, id, page, limit) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllActivityByType/${apiType}/${id}?page=${page}&limit=${limit}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateActivityStatus(id, status) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/updateActivityStatus/${id}/${status}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function importData(payload) {
    try {
        const response = await getAxiosInstance().post(`/importData/${12345}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchFileAsBufferFile(fileName) {
    try {
        const data = await getAxiosInstance().get(`/importData/fetchFileAsBuffer?fileUrl=${fileName}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getBussinesDaysForStaffRole(id, startDate, endDate) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getBussinesDaysForStaffRole/${startDate}/${endDate}/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function importApiCall(apiEndpoint, url, formData) {
    try {
        const response = await getAxiosInstance().post(`${apiEndpoint}${url}`, formData);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findGoalsTargetByUserId(id, year) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findGoalsTargetByUserId/${id}/${year}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findGoalsTargetByUser(year) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findGoalsTargetByUser/${year}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchAllReportiesGoals(year) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllReportiesGoals/${year}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchAllAccountsByOwnerId(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountsByOwnerId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchAllReportiesGoalsByUserId(year, id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllReportiesGoalsByUserId/${year}/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createGoalsTarget(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createGoalsTarget`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateGoalsTarget(payload, glsAdTrtId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateGoalsTarget/${glsAdTrtId}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteGoalsTarget(id) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteGoalsTarget/${id}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function saveUserDataConfig(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/saveUserDataConfig`, payload);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateUserDataConfig(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/UserDataConfig/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getUserDataConfig(configId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/UserDataConfig/${configId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getExchangeRate(base, target) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getExchangeRate/${base}/${target}`);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllCurrencies() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllCurrencies`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createCurrency(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/createCurrency`, payload);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateCurrency(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCurrency/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function leadInsights(companyCode, entityId) {
    try {
        const response = await getAxiosInstance().get(`/leadInsights/${companyCode}/${entityId}`);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function contactInsights(companyCode, entityId) {
    try {
        const response = await getAxiosInstance().get(`/contactInsights/${companyCode}/${entityId}`);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function accountInsights(companyCode, entityId) {
    try {
        const response = await getAxiosInstance().get(`/accountInsights/${companyCode}/${entityId}`);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function dealInsights(companyCode, entityId) {
    try {
        const response = await getAxiosInstance().get(`/dealInsights/${companyCode}/${entityId}`);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function importDemoData() {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/importDemoData`, {});
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function TemplateBuilderAi(companyId, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/emailTemplateBuilderAi/${companyId}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function LaunchPadBuilderAi(companyId, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/launchPadBuilderAi/${companyId}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function GenerateEmailContentByAi(companyId, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/generateEmailContentByAi/${companyId}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    GenerateEmailContentByAi,
    TemplateBuilderAi,
    importDemoData,
    leadInsights,
    dealInsights,
    accountInsights,
    contactInsights,
    createCurrency,
    updateCurrency,
    getAllCurrencies,
    saveUserDataConfig,
    updateUserDataConfig,
    getUserDataConfig,
    getExchangeRate,
    getAllCompanyRoles,
    updateGoalsTarget,
    createGoalsTarget,
    deleteGoalsTarget,
    fetchAllReportiesGoals,
    findGoalsTargetByUser,
    findGoalsTargetByUserId,
    fetchAllAccountsByOwnerId,
    fetchAllReportiesGoalsByUserId,
    importApiCall,
    getAllActivityByType1,
    getAllActivityByType,
    updateActivityStatus,
    resetNewPassword,
    forgotPassword,
    sendEmailOtpForForgotPassword,
    login,
    loginFromTwoFactorAuthentication,
    getCityData,
    getStateData,
    getAllUsersData,
    IndustryData,
    getLeadsourceData,
    getLeadStatusData,
    getSeniorityLevelData,
    getCountryData,
    getColumnConfigs,
    SharingPermissions,
    MultiFileUpload,
    FetchAllAttendeeList,
    getMyTerritory,
    getTeamTerritory,
    getBusinessRuleEntity,
    getTriggerFiledforEntity,
    getTimeZoneData,
    getLanguage,
    getSystemRole,
    getCompanyRole,
    getTitle,
    getAnnualRevenue,
    getNoofEmployee,
    getRating,
    getProdCategory,
    getUserDepartment,
    getDateFormate,
    getTimeFormate,
    FetchDealByEntity,
    getScoringDetails,
    getMailInfo,
    getAllUsersByAdmin,
    FecthTableNames,
    FecthModuleDecryptedToken,
    FecthModuleEncryptedToken,
    LogOutApi,
    getsyatemRolePermission,
    taskReminderAndOverdue,
    approvalRequestReminderAndOverdue,
    checkedAccountExpire,
    triggerMailForExpiringTrialAccount,
    triggerMailForExpiredTrialAccount,
    fetchFileAsBufferFile,
    getBussinesDaysForStaffRole,
    importData,
    createExportLog,
    loginStatus,
    LaunchPadBuilderAi,
    getLeadMailInfo,
}